<div class="content">
  <div class="message empty-content">
    <span class="mat-h2">Olá {{ user.firstname }}! Seja bem-{{ user.gender === "masculino" ? "vindo" : "vinda" }}.<br/> Boa Sorte!</span>
  </div>

  <span class="mat-title">Seu progresso</span>

  <div class="status">
    <!--<mat-grid-list [rowHeight]="(isMobile$ | async) ? '3:2' : '1:1'" [cols]="(isMobile$ | async) ? 1 : 3">-->
    <mat-grid-list rowHeight="1:1" [cols]="3">
      <mat-grid-tile>
        <div class="status-info">
          <div class="circle searched">
            <span class="total">
              {{ actions.searched?.total || 0 }}
            </span>
            <small *ngIf="actions.searched?.total > 0 && (isMobile$ | async) == false">
              Ult. ves {{ actions.searched?.last_update | date : "dd/MM" }}
            </small>
          </div>

          <span class="mat-body-2"> Pesquisado </span>
        </div>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="status-info">
          <div class="circle viewed">
            <span class="total">
              {{ actions.viewed?.total || 0 }}
            </span>
            <small *ngIf="actions.viewed?.total > 0 && (isMobile$ | async) == false">
              Ult. ves {{ actions.viewed?.last_update | date : "dd/MM" }}
            </small>
          </div>

          <span class="mat-body-2"> Analisado </span>
        </div>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="status-info">
          <div class="circle selected">
            <span class="total">
              {{ actions.selected?.total || 0 }}
            </span>
            <small *ngIf="
                actions.selected?.total > 0 && (isMobile$ | async) == false
              ">
              Ult. ves {{ actions.selected?.last_update | date : "dd/MM" }}
            </small>
          </div>

          <span class="mat-body-2"> Selecionado </span>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div class="container-mat-process">
    <span class="mat-title mat-title-process"> Processos seletivos disponíveis </span>
    
    <button mat-stroked-button color="primary" (click)="openViewProcessList()" class="right-button" [disabled]="checkView">
      <mat-icon>settings</mat-icon> configurações
    </button>  
  </div>
  <div class="empty-content" *ngIf="processLists?.length === 0">
    <span class="mat-body-2">Não há processos seletivos disponíveis no momento.</span>
  </div>

  <mat-action-list>
    <ng-container *ngFor="let processList of processLists">
    <button
      mat-list-item
      *ngIf="processList.viewprocess == 'true'"
    >
      <div class="mat-list-text" (click)="openProcessList(processList)">
        <h3 matLine>{{ processList.name }}</h3>
        <p matLine *ngIf="processList.sinonimo">
          Cargo: {{ processList.sinonimo }}
        </p>
        <p matLine *ngIf="processList.viewname === 'true'">
          Empresa: {{ processList.companyname }}
        </p>
        <p matLine *ngIf="processList.viewtel === 'true'">
          Telefone: {{ formatPhoneNumber(processList.phone) }}
        </p>
        <p matLine>
          Criado em {{ processList.created_at | date : "dd/MM/yyyy" }}
        </p>
        <span
          matLine
          *ngIf="processList.pendingInterview > 0"
          style="color: brown"
        >
          {{ processList.pendingInterview }} solicitação(ões) de entrevista(s)
        </span>
        <span
          matLine
          *ngIf="processList.pendingTest > 0"
          style="color: brown"
        >
          {{ processList.pendingTest }} novo(s) teste(s) aguardando
        </span>
        <span
          matLine
          *ngIf="processList.candidateStatus === 'hired'"
          style="color: #093"
        >
          <span class="mat-body-2">Parabéns, você está contratado!</span>
        </span>
      </div>
      <div [ngSwitch]="processList.candidateStatus" *ngIf="!(processList.status === 'finished' || processList.status === 'archived')">
        <span *ngSwitchCase="'hired'" class="statusbar finish" (click)="infoprocess('contratado')"><small>Finalizado</small></span>
        <span *ngSwitchCase="'waiting'" class="statusbar progress" (click)="infoprocess('process')"><small>Em andamento</small></span>
        <span *ngSwitchCase="'pending'" class="statusbar progress" (click)="infoprocess('process')"><small>Em andamento</small></span>
        <span *ngSwitchCase="'disabled'" class="statusbar finish" (click)="infoprocess('finish')"><small>Finalizado</small></span>
        <span *ngSwitchCase="'pre-approval'" class="statusbar progress" (click)="infoprocess('process')"><small>Em andamento</small></span>
        <!-- <span *ngSwitchDefault>Estado Desconhecido</span> Caso queira tratar um valor não previsto -->
      </div>
      <div [ngSwitch]="processList.candidateStatus" *ngIf="(processList.status === 'finished' || processList.status === 'archived')">
        <span *ngSwitchCase="'hired'" class="statusbar finish" (click)="infoprocess('contratado')"><small>Finalizado</small></span>
        <span *ngSwitchCase="'waiting'" class="statusbar progress" (click)="infoprocess('process')"><small>Em andamento</small></span>
        <span *ngSwitchCase="'pending'" class="statusbar progress" (click)="infoprocess('process')"><small>Em andamento</small></span>
        <span *ngSwitchCase="'disabled'" class="statusbar finish" (click)="infoprocess('finish')"><small>Finalizado</small></span>
        <span *ngSwitchCase="'pre-approval'" class="statusbar progress" (click)="infoprocess('process')"><small>Em andamento</small></span>
      </div>
      <div *ngIf="processList.candidateStatus !== 'hired'">
          <button color="primary" mat-icon-button title="Ocultar processo seletivo"
          (click)="viewProcessList($event, user.id, processList.id)">
          <mat-icon>visibility_off</mat-icon>
          </button>
      </div>
    </button>
  </ng-container>
  </mat-action-list>  
</div>
